module.exports = __webpack_public_path__ + "img/pk-jk.7ab85a82.svg";